import React from 'react';
import {twMerge} from 'tailwind-merge';

import {PANEL_VERTICAL_DROP_INDICATOR_WIDTH_TW} from '../utils';

/**
 * When a panel is being dragged over a section, this component is used to show a vertical drop indicator.
 * To keep things simple and performant, we do not want to shift the panels in the other sections.
 * We also do not want to useState to manage the styles.
 */
export const PanelCrossSectionDropIndicator = React.forwardRef<
  HTMLDivElement,
  {}
>((_, ref) => {
  return (
    <div
      ref={ref}
      className={twMerge(
        'fixed left-0 top-0',
        'h-0', // height will be set by ref
        PANEL_VERTICAL_DROP_INDICATOR_WIDTH_TW,
        'bg-moon-350',
        'rounded-xs',
        'z-[1]',
        'opacity-0' // Start hidden
      )}
    />
  );
});
